import { render, staticRenderFns } from "./BlankPaySlipPreview.vue?vue&type=template&id=479661a6&"
import script from "./BlankPaySlipPreview.vue?vue&type=script&lang=js&"
export * from "./BlankPaySlipPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports